import { render } from "./SuperVisaInsuranceForm.vue?vue&type=template&id=71fc19e5&scoped=true"
import script from "./SuperVisaInsuranceForm.vue?vue&type=script&lang=js"
export * from "./SuperVisaInsuranceForm.vue?vue&type=script&lang=js"

import "./SuperVisaInsuranceForm.vue?vue&type=style&index=0&id=71fc19e5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fc19e5"]])

export default __exports__